import vars from '../../vars';

$(document).ready(function() {
	    vars.$asideFilterComponent.find("h3").click(function(){
      $(this).parent().toggleClass('active');
    });
});


function windowSize(){
  if ($(window).width() >= '1024'){
      $('.b-aside-filter__component').addClass('active')
  } else {
      $('.b-aside-filter__component').removeClass('active')
      $('.b-aside-filter__component:first').addClass('active')
  }
}
$(window).on('load resize',windowSize);


// WEBPACK FOOTER //
// ./src/js/pages/materials/aside-accordion.js